import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-logo-footer';
export var ID = 'icon-logo-footer';
/* eslint-disable max-len */

var SVGLogoFooter = function SVGLogoFooter() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 21 29"
  }, React.createElement("path", {
    d: "M20.984375,18.3788042 C20.984375,24.1113409 16.2884677,28.7576084 10.4915975,28.7576084 C4.69944742,28.7593595 0,24.1119246 0,18.3788042 C0,12.6468511 4.69944742,8 10.4910075,8 C16.2884677,8 20.984375,12.6468511 20.984375,18.3788042",
    id: "Fill-1-Copy-2"
  }), React.createElement("path", {
    d: "M11.9905927,1.4148935 C10.9002501,1.24561994 10.0152318,1.24912215 9.25647603,1.1428884 C8.31776657,1.07109306 6.54241977,0.827105648 6.02910913,0 C6.02910913,0 6.01730889,0.0735464444 6.00904872,0.209548996 C5.9889883,0.513657707 5.98721826,1.12245883 6.16835202,1.90637053 C6.34063559,2.56887224 6.58962075,3.24596649 6.94303808,3.88862232 C7.05632043,4.0917506 7.1855331,4.29721368 7.32772605,4.50559527 C8.20389421,5.76347295 9.59396303,6.66120653 11.6837864,7.12758438 C14.4238032,7.73755291 17.0239871,8.17649677 19.0418289,10.7185187 C19.046549,10.7085958 19.048909,10.6957543 19.0542191,10.684664 C19.4253368,9.30596002 18.0193377,2.34414699 11.9905927,1.4148935",
    id: "Fill-2-Copy-2"
  }));
};
/* eslint-disable max-len */


var LogoFooter = function LogoFooter(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGLogoFooter
  });
};

LogoFooter.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default LogoFooter;